import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';
import { EmailRelinkPopupComponent } from 'src/app/Shared/email-relink-popup/email-relink-popup.component'
import { IStoreNameChange } from '../../Shared/interface2';
import { Subject } from 'rxjs';
import { twoWayService } from 'src/app/services/operations/two-way-text.service';
import { StoreService } from 'src/app/services/stores.service';
import { NotificationService } from 'src/app/services/operations/notification.service';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app.service';
import { EmailAndSMSService } from 'src/app/services/operations/EmailAndSMS.service';

@Component({
  selector: 'app-email-bar',
  templateUrl: './email-bar.component.html',
  styleUrls: ['./email-bar.component.scss'],
  standalone: false
})
export class EmailBarComponent implements OnInit, OnDestroy {
  private baseURL = this.appService.config.apiBaseUrl;
  public loaderIcon: Promise<boolean>;
  private storeSub: any;
  @Input() isAdmin: boolean;
  @Input() isCallCenterAgent: boolean;
  @Output() emailPopup = new EventEmitter<void>();
  @Output() initiateDelNotify = new EventEmitter<number>();
  @Input() lastAccessedFacility: number;
  @Input() toasterConfig: Object;
  @Input() AdminOrOps: string;
  @Input() storeNameChange: Subject<IStoreNameChange>;
  notifications: any[] = [];
  EmailNotifications: any[] = [];
  selectedPhoneId: number;
  isEmailPopupOpen = false;
  pageSize = 12;
  pageCount = 0;
  isLoading = false;
  hasMoreRecords = true;
  getemailNotificationCountObj;
  emailnotificationSub: any;
  counts = {
    all: 0,
  };

  constructor(
    private storeService: StoreService,
    private toastr: ToastrService,
    private notificationService: NotificationService,
    private appService: AppService,
    private twoWayService: twoWayService,
    private emailAndSMSService: EmailAndSMSService,
    private modalWrapper: ModalWrapperService,
  ) { }

  ngOnInit(): void {
    this.emailNotificationHub(this.lastAccessedFacility);
    this.storeSub = this.storeNameChange.subscribe(val => {
      const lastAccessedFacility = val.Id;
      if (!lastAccessedFacility) {
        return;
      }
      this.lastAccessedFacility = lastAccessedFacility;
      this.notifications = [];
      this.EmailNotifications = [];
      this.pageCount = 0;
      this.hasMoreRecords = true;
      this.emailNotificationHub(lastAccessedFacility);
    });
  }

  openEmailPopup(): void {
    this.isEmailPopupOpen = true;
    this.loadEmailNotifications(true);
  }

  emailNotifications(): void {
    this.EmailNotifications = this.notifications;
    }

  emailNotificationHub(facilityId: number): void {
    if (!this.notificationService.isConnectedTo(facilityId)) {
      this.notificationService.stopConnection();
      this.notificationService.startConnection(this.baseURL, facilityId);
    }
    this.emailnotificationSub = this.notificationService.emailNotificationCount$
      .subscribe((response: any) => {
        if (!response) {
          return;
        }
        this.counts = {
          all: response.Total,
        };
      });
  }

  getTimeDisplay(time: string): string {
    if (!time) {
      return '';
    }
    const emailTime = new Date(time);
    const now = new Date();
    const diffMs = now.getTime() - emailTime.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    // Less than 5 mins
    if (diffMinutes < 5) {
      return 'Just now';
    }
    // Less than 1 hour
    if (diffMinutes < 60) {
      return `${diffMinutes} min ago`;
    }
    // Less than 24 hours
    if (diffHours < 24) {
      const remainingMinutes = diffMinutes % 60;
      if (remainingMinutes === 0) {
        return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
      }
      return `${diffHours} hour${diffHours > 1 ? 's' : ''} ${remainingMinutes} min ago`;
    }
    // More than 24 hours
    const month = String(emailTime.getMonth() + 1).padStart(2, '0');
    const day = String(emailTime.getDate()).padStart(2, '0');
    const year = emailTime.getFullYear();
    const hours = String(emailTime.getHours()).padStart(2, '0');
    const minutes = String(emailTime.getMinutes()).padStart(2, '0');
    return `${month}/${day}/${year} ${hours}:${minutes}`;
  }

  // FR-12 — mark as read when user opens a notification
  onNotificationClick(email: any): void {
    if (!email?.isRead && email?.id) {
      this.emailAndSMSService.markEmailAsRead({ EmailLogId: email.id, FacilityId: this.lastAccessedFacility }).subscribe({
        next: () => { email.isRead = true; }
      });
    }
  }

  // FR-13 — mark all unread emails as read
  markAllAsRead(): void {
    if (!this.lastAccessedFacility) { return; }
    this.emailAndSMSService.markAllEmailsAsRead({ FacilityId: this.lastAccessedFacility }).subscribe({
      next: () => {
        this.notifications.forEach(n => { n.isRead = true; });
        this.counts = { all: 0 };
      }
    });
  }

  openRelinkPopup(email: any): void {
    // GAP-15 — use email.id directly; field name matches EmailRelinkPopupComponent.proceedRelink()
    this.loaderIcon = Promise.resolve(true);
    this.storeService.getStores().subscribe({
      next: (stores) => {
        this.loaderIcon = Promise.resolve(false);

        const modalRef: BsModalRef = this.modalWrapper.openComponent(
          EmailRelinkPopupComponent,
          {
            initialState: {
              emailData: {
                EmailId: email.Id,
                parentModal: null
              },
              allStores: stores
            },
            class: 'modal-xl',
            backdrop: 'static',
            keyboard: false
          }
        );
        modalRef.content.onRelinkSuccess.subscribe((result) => {
          this.loadEmailNotifications(true);
          if (result?.success) {
            this.toastr.success('Relink email was successful', 'Success', this.toasterConfig);
          } else {
            this.toastr.error('Failed to relink email', 'Failure', this.toasterConfig);
          }
        });
      },
      error: () => {
        this.loaderIcon = Promise.resolve(false);
      }
    });
  }
  cancel(): void {
    this.isEmailPopupOpen = false;
  }
  confirmDelete(Id: number): void {
    this.initiateDelNotify.emit(Id);
  }
  loadEmailNotifications(reset: boolean = false): void {
    if (reset) {
      this.pageCount = 0;
      this.notifications = [];
      this.hasMoreRecords = true;
    }
    if (this.isLoading || !this.hasMoreRecords) {
      return;
    }
    this.isLoading = true;
    const input = {
      facilityId: this.lastAccessedFacility,
      pageModel: {
        pageCount: this.pageCount,
        pageSize: this.pageSize
      }
    };
    this.emailAndSMSService.GetIncomingEmailList(input).subscribe({
      next: (response: any[]) => {
        if (!response || response.length === 0) {
          this.hasMoreRecords = false;
          this.isLoading = false;
          return;
        }
        this.notifications = [
          ...this.notifications,
          ...response
        ];
        this.pageCount += response.length;
        if (response.length < this.pageSize) {
          this.hasMoreRecords = false;
        }
        this.emailNotifications();
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }
  onNotificationScroll(event: Event): void {
    const element = event.target as HTMLElement;
    const atBottom =
      element.scrollTop + element.clientHeight >=
      element.scrollHeight - 50;
    if (atBottom) {
      this.loadEmailNotifications();
    }
  }
  ngOnDestroy() {
    if (this.emailnotificationSub) {
      this.emailnotificationSub.unsubscribe();
    }
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
  }
}
